import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import Seo from "../Components/seo/Seo";

function Contact() {
  const [formState, setFormState] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    organisation: '',
    message: '',
    errors: {
      fullName: '',
      phoneNumber: '',
      email: '',
      organisation: '',
      message: '',
    },
    successMessage: '',
  });

  const validateForm = () => {
    const errors = {
      fullName: formState.fullName.trim() === '' ? 'Full Name is required' : '',
      phoneNumber: formState.phoneNumber.trim() === '' ? 'Phone Number is required' : '',
      email: !/^\S+@\S+\.\S+$/.test(formState.email) ? 'Invalid email address' : '',
      organisation: formState.organisation.trim() === '' ? 'Organisation is required' : '',
      message: formState.message.trim() === '' ? 'Message is required' : '',
    };

    setFormState(prevState => ({ ...prevState, errors }));
    return Object.values(errors).every(error => error === '');
  };

  const sendEmail = async e => {
    e.preventDefault();

    if (validateForm()) {
      try {
        setFormState(prevState => ({ ...prevState, loading: true })); 
        await emailjs.sendForm('service_k7yar8i', 'template_dm5wmqn', e.target, 'h-QrtZQ3fBDhhtPSm');
        setFormState({
          fullName: '',
          phoneNumber: '',
          email: '',
          organisation: '',
          message: '',
          errors: {
            fullName: '',
            phoneNumber: '',
            email: '',
            organisation: '',
            message: '',
          },
          successMessage: 'Email sent successfully!',
          loading: false,
        });
      } catch (error) {
        console.error('Error sending email:', error);
        setFormState(prevState => ({
          ...prevState,
          successMessage: 'Failed to send email. Please try again later.',
          loading: false, 
        }));
      }
    }
  };

  return (
    <div className="bg-white">
      <Seo
        title="Contact"
        description="Contact EasyBooks Solutions for demos, pricing, customization, and software delivery support."
      />
      <section className="eb-section">
        <div className="eb-container">
          <div className="grid gap-10 lg:grid-cols-2">
            <div>
              <div className="eb-pill">Contact</div>
              <h1 className="mt-4 eb-h1">Let’s talk.</h1>
              <p className="mt-4 text-lg eb-muted">
                Tell us what you’re trying to achieve. We’ll respond quickly with next steps and the best solution
                path product, service, or both.
              </p>

              <div className="mt-8 space-y-2 text-sm text-slate-700">
                <div className="font-semibold text-slate-900">EasyBooks Solutions</div>
                <div>Area 47, sector 5, Near Zodiak Broadcasting Station</div>
                <div>
                  <a className="eb-link" href="tel:+265884675719">
                    +265 884 675 719
                  </a>
                </div>
                <div>
                  <a className="eb-link" href="mailto:info@ebsolutionsmw.com">
                    info@ebsolutionsmw.com
                  </a>
                </div>
              </div>

            {/* <a href="/Wp Code" className="justify-self-center">
              <button className="justify-self-center transition duration-300 bg-transparent hover:bg-green-500 text-green-700 hover:text-white py-1 px-3 border border-green-700 hover:border-transparent rounded-full">
                <i className="fab fa-whatsapp"></i>
              </button>
            </a> */}
              <div className="mt-8 overflow-hidden">
                <img
                  src="Assets/Talk.jpg"
                  alt="Contact EasyBooks Solutions"
                  className="h-64"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            <div className="eb-card p-6 sm:p-8">
              <form className="contact_form" onSubmit={sendEmail}>
                {formState.successMessage ? (
                  <div className="mb-4 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700">
                    {formState.successMessage}
                  </div>
                ) : null}
                {formState.loading ? (
                  <p className="mb-4 text-sm text-slate-600">Please wait, sending email…</p>
                ) : null}

                <div className="grid gap-4 sm:grid-cols-2">
                  <div>
                    <label className="text-sm font-semibold text-slate-900" htmlFor="fullname">
                      Full name
                    </label>
                    <input
                      name="fullName"
                      type="text"
                      className="mt-2 block w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-brand-600"
                      id="fullname"
                      placeholder="Jane Doe"
                      value={formState.fullName}
                      onChange={e => setFormState(prevState => ({ ...prevState, fullName: e.target.value }))}
                    />
                    {formState.errors.fullName ? (
                      <div className="mt-1 text-xs text-red-600">{formState.errors.fullName}</div>
                    ) : null}
                  </div>

                  <div>
                    <label className="text-sm font-semibold text-slate-900" htmlFor="phoneNumber">
                      Phone number
                    </label>
                    <input
                      name="phoneNumber"
                      type="text"
                      className="mt-2 block w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-brand-600"
                      id="phoneNumber"
                      placeholder="+265 ..."
                      value={formState.phoneNumber}
                      onChange={e => setFormState(prevState => ({ ...prevState, phoneNumber: e.target.value }))}
                    />
                    {formState.errors.phoneNumber ? (
                      <div className="mt-1 text-xs text-red-600">{formState.errors.phoneNumber}</div>
                    ) : null}
                  </div>
                </div>

                <div className="mt-4 grid gap-4 sm:grid-cols-2">
                  <div>
                    <label className="text-sm font-semibold text-slate-900" htmlFor="email">
                      Email
                    </label>
                    <input
                      name="email"
                      type="email"
                      className="mt-2 block w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-brand-600"
                      id="email"
                      placeholder="you@company.com"
                      value={formState.email}
                      onChange={e => setFormState(prevState => ({ ...prevState, email: e.target.value }))}
                    />
                    {formState.errors.email ? (
                      <div className="mt-1 text-xs text-red-600">{formState.errors.email}</div>
                    ) : null}
                  </div>

                  <div>
                    <label className="text-sm font-semibold text-slate-900" htmlFor="organisation">
                      Organisation
                    </label>
                    <input
                      name="organisation"
                      type="text"
                      className="mt-2 block w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-brand-600"
                      id="organisation"
                      placeholder="Company / Institution"
                      value={formState.organisation}
                      onChange={e => setFormState(prevState => ({ ...prevState, organisation: e.target.value }))}
                    />
                    {formState.errors.organisation ? (
                      <div className="mt-1 text-xs text-red-600">{formState.errors.organisation}</div>
                    ) : null}
                  </div>
                </div>

                <div className="mt-4">
                  <label className="text-sm font-semibold text-slate-900" htmlFor="message">
                    Message
                  </label>
                  <textarea
                    name="message"
                    className="mt-2 block w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-brand-600"
                    id="message"
                    rows="5"
                    placeholder="What are you trying to improve?"
                    value={formState.message}
                    onChange={e => setFormState(prevState => ({ ...prevState, message: e.target.value }))}
                  />
                  {formState.errors.message ? (
                    <div className="mt-1 text-xs text-red-600">{formState.errors.message}</div>
                  ) : null}
                </div>

                <button type="submit" className="eb-btn-primary w-full mt-6">
                  Send message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
